import React, { useMemo, useState } from 'react';
import useTable from 'shared/hooks/customHooks/useTable';
import UnassignedAccountsTable from './UnassignedAccountsTable';
import { UnassignedAccountProps, UnassignedAccountsProps } from './Interfaces';
import UnassignedAccountsHeader from './UnassignedAccountsHeader';

import styles from './UnassignedAccounts.module.scss';

const UnassignedAccounts: React.FC<UnassignedAccountsProps> = ({ unassignedAccounts }) => {
  const [search, setSearch] = useState<string>('');
  const [selectedAccounts, setSelectedAccounts] = useState<UnassignedAccountProps[]>([]);
  const { NewTableWrapper } = useTable();

  const filteredUnassignedAccounts = useMemo(() => {
    return unassignedAccounts.filter((account) => {
      const accountName = account.linkedAccountName?.toLowerCase();
      const payerName = account.payerAccountName?.toLowerCase();
      return accountName.includes(search.toLowerCase()) || payerName.includes(search.toLowerCase());
    });
  }, [unassignedAccounts, search]);

  return (
    <div className={styles.unassignedAccountsContainer}>
      <NewTableWrapper className="sub-table" isCompact>
        <UnassignedAccountsHeader search={search} setSearch={setSearch} selectedAccounts={selectedAccounts} />
        <UnassignedAccountsTable
          unassignedAccounts={filteredUnassignedAccounts}
          onSelectionChange={(selected: []) => setSelectedAccounts(selected)}
          selectedAccounts={selectedAccounts}
        />
      </NewTableWrapper>
    </div>
  );
};

export default UnassignedAccounts;
